import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { NewUiToggleswitchComponent } from "../../shared/form/toggleswitch/new-ui-toggleswitch.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-input-switch",
  templateUrl: "./new-ui-formly-inputSwitch.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    FormlyModule,
    Message,
    NewUiToggleswitchComponent,
  ],
})
export class NewUiFormlyInputSwitchComponent extends FieldType {
  override defaultOptions = {
    props: {
      hideLabel: true,
    },
  };
}
